export default __webpack_public_path__ + "static/slider-la-mobile-e6c29ff48a0ca507b475a01ad4856363.jpg";